"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _RadioItem = _interopRequireDefault(require("./RadioItem.style"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _utils = _interopRequireDefault(require("../../utils/utils"));

var _dec, _class;

let RadioItem = (_dec = (0, _reactJss.default)(_RadioItem.default), _dec(_class = class RadioItem extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.handleOnClick = this.handleOnClick.bind(this);
  }

  handleOnClick() {
    const {
      value,
      visibility,
      onChange
    } = this.props;
    if (visibility === 'disabled') return;
    onChange(value);
  }

  render() {
    const {
      id,
      classes,
      className,
      visibility,
      value,
      label,
      activeItem,
      children,
      dataTestId
    } = this.props;

    const uniqId = _utils.default.random();

    const isChecked = activeItem === value;
    return /*#__PURE__*/_react.default.createElement("div", {
      id: id,
      className: (0, _clsx.default)(className, classes.radioItem, {
        checked: isChecked
      }, {
        hidden: visibility === 'hidden'
      }, {
        disabled: visibility === 'disabled'
      }),
      "data-testid": dataTestId ? `${dataTestId}-container` : undefined
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.content
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: classes.input,
      type: "radio",
      value: isChecked,
      id: `id-${uniqId}`,
      onClick: this.handleOnClick,
      "data-testid": dataTestId
    }), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: classes.icon,
      type: isChecked ? 'radio_on' : 'radio_off',
      size: "medium",
      color: "currentColor"
    }), /*#__PURE__*/_react.default.createElement("label", {
      className: classes.label,
      htmlFor: `id-${uniqId}`
    }, /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: _utils.default.bbCodeToHtml(label)
      }
    }))), children && /*#__PURE__*/_react.default.createElement("div", {
      className: classes.children
    }, children));
  }

}) || _class);
RadioItem.defaultProps = {
  id: null,
  children: null,
  error: false,
  value: false,
  visibility: 'visible',
  onChange: () => {}
};
var _default = RadioItem;
exports.default = _default;